import React from 'react';
import classes from './Control.scss';
import PropTypes from 'prop-types';

const Control = ({ onSubmit, onCancel }) => (
  <div className={classes['control']}>
    <ul>
      <li><a onClick={onSubmit}>Save</a></li>
      <li><a onClick={onCancel}>Cancel</a></li>
    </ul>
  </div>
);

Control.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default Control;
